import { render, staticRenderFns } from "./UserCardPanel.vue?vue&type=template&id=a7b4d430&scoped=true"
import script from "./UserCardPanel.vue?vue&type=script&lang=js"
export * from "./UserCardPanel.vue?vue&type=script&lang=js"
import style0 from "./UserCardPanel.vue?vue&type=style&index=0&id=a7b4d430&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7b4d430",
  null
  
)

export default component.exports